import React, { FC } from 'react';

import { Box, Grid } from '@mui/material';

import ApprovalAutomationsSection from '../../waterAuthoritySubmissions/components/ApprovalAutomationsSection';
import ContactInfoUpdatingFields from '../../waterAuthorityConfig/components/ContactInfoUpdatingFields';
import WaterAuthorityUpdatingFields from '../../waterAuthorityConfig/components/WaterAuthorityUpdatingFields';

import { BackflowJobGroup } from '../../model';

interface ApproverUpdatingPanelProps {
  backflowJobGroup: BackflowJobGroup;
  backflowJobGroupId: string;
  fetchBackflowJobGroup: () => void;
}

const ApproverUpdatingPanel: FC<ApproverUpdatingPanelProps> = ({
  backflowJobGroup,
  backflowJobGroupId,
  fetchBackflowJobGroup,
}) => {
  return (
    <Grid container>
      <Grid item xs={12} md={6} style={{ marginBottom: 10 }}>
        <ContactInfoUpdatingFields
          contactId={backflowJobGroup.primary_contact_id}
          firstName={backflowJobGroup.primary_contact_first_name}
          lastName={backflowJobGroup.primary_contact_last_name}
          fetchBackflowJobGroup={fetchBackflowJobGroup}
          backflowJobGroupId={backflowJobGroupId}
        />
        <Box style={{ marginTop: 20 }}>
          <WaterAuthorityUpdatingFields
            backflowJobGroup={backflowJobGroup}
            fetchBackflowJobGroup={fetchBackflowJobGroup}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={6} style={{ marginBottom: 10 }}>
        <ApprovalAutomationsSection backflowJobGroupId={backflowJobGroupId ?? ''} />
      </Grid>
    </Grid>
  );
};

export default ApproverUpdatingPanel;
